import React from 'react';

import ItemFinderLegendbar from '~/frontend/src/components/base/ItemFinder/common/ItemFinderLegendbar';

export const getItemFinderLegendbar = ( uid : string, schema : Schema, rawMode : boolean, showAdditionalRawNames : boolean, visible : boolean ) : JSX.Element => {
    return <ItemFinderLegendbar
        key={`${uid}_legendbar`}

        uid={uid}

        schema={schema}

        rawMode={rawMode}
        showAdditionalRawNames={showAdditionalRawNames}

        visible={visible}
    />;
}
